const util = require('./util');

module.exports = (config, slotBidderCfg) => {
	return {
		'bidder': slotBidderCfg.bidder,
		'params': util.getParamsFromConfig(config, slotBidderCfg)
	};
};
